import SignInForm from '../forms/SignIn';
import AuthLayout from '../Assets/AuthLayout';

const SignInPage = () => {

  return (
    <AuthLayout>
      <div className="w-full max-w-sm h-full overflow-y-auto">
        <SignInForm />
      </div>
    </AuthLayout>
  );
};

export default SignInPage;